import { cn } from "@/lib/utils";

export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src="/logo.svg"
      alt=""
      draggable={false}
      className={cn("aspect-square size-8 shrink-0 rounded-lg", className)}
    />
  );
}

/**
 * The SKYNET wordmark. Takes its colour from `currentColor`; size it by height.
 * Strokes run past the viewBox on purpose so the SVG viewport crops them flat.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 90.5 10"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      role="img"
      aria-label="Skynet"
      className={cn("h-3 w-auto shrink-0 overflow-hidden", className)}
    >
      <path d="M12 1H3L1 3V5H11V7L9 9H0" />
      <path d="M17 -1V11M17 5H21M27 -1L21 5L27 11" />
      <path d="M32.5 -1V3L34.5 5H40.5L42.5 3V-1M37.5 5V11" />
      <path d="M48.5 11V0L58.5 10V-1" />
      <path d="M74.5 1H66.5L64.5 3V9H74.5M64.5 5H72.5" />
      <path d="M78.5 1H90.5M84.5 1V11" />
    </svg>
  );
}
